export class MasterTimeBaseContractProfile {
  TIMEBASECONTPROFILE_ID: number;
  PROFILE_NAME: string;
  PROFILE_TYPE: string;
  PROFILE_ID: number;
  GLOBALANTIPASSBACK: boolean;
  ENTRYOUTSITETIMESLOTENABLE: boolean;
  EXITOUTSITETIMESLOTENABLE: boolean;
  ACCESS_POLICY_ID: number;
  DURATION_START_TYPE: string;
  VALIDITY_START_DAYS: number;
  VALIDITY_START_MINUTES: number;
  DURATION_END_TYPE: string;
  END_TIME_VALUE: number;
  END_TIME_UNIT: string;
  GLOBAL_ISSUE_BUSINESS_CUSTOMER: boolean;
  RENEWAL_ALLOW: boolean;
  RENEWAL_DAYS: number;
  SALE_PRICE: number;
  PRICE_METHOD: string;
  RESERVE_PARKING_PLACE: boolean;
  ALLOW_TRANSIT_PLATE: boolean;
  UPDATE_ASSOCIATED_CARDS: boolean;
  LATE_RECHARGE_RENEW_PAYMENT: number;
  LATE_RECHARGE_RENEW_PAYMENT_PRICE_METHOD: string;
  ADMINISTRATIVE_SALE_PRICE: number;
  ADMINISTRATIVE_SALE_PRICE_ENABLE: boolean;
  ADMINISTRATIVE_PRICE_METHOD: string;
  RATE_PROFILE_ID: number;
}
